import styled from 'styled-components';

export const Dropzone = styled.label`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 300px;
  color: #bdbdbd;
  border: 2px dashed #eeeeee;
  background-color: #fafafa;
  font-size: 18px;
  cursor: pointer;

  /* input {
    display: none;
  } */
`;
